import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  Container,
  Box,
  IconButton,
  MenuItem,
  Popper,
  Fade,
  ClickAwayListener,
  MenuList,
  List,
  Collapse,
  ListItemButton,
  ListItemText,
  SwipeableDrawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import logo from "images/logo_no_text_no_outline_no_background.png";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink, useLocation } from "react-router-dom";

const pages = [
  {
    title: "The Wedding",
    path: "the-wedding",
    pages: [
      { title: "Our Story", path: "our-story" },
      { title: "Wedding Party", path: "wedding-party" },
      { title: "Itinerary", path: "itinerary" },
      { title: "FAQ's", path: "faqs" },
    ],
  },
  {
    title: "The Venue",
    path: "the-venue",
    pages: [
      { title: "Directions", path: "directions" },
      { title: "Accommodations", path: "accommodations" },
      { title: "Camp Map", path: "camp-map" },
    ],
  },
  { title: "The Registry", path: "the-registry" },
  {
    title: "The Pictures",
    path: "the-photos",
    pages: [
      { title: "Couples Photos", path: "our-photos" },
      { title: "Wedding Photos", path: "wedding-photos" },
      { title: "Upload", path: "upload" },
    ],
  },
  { title: "The Stream", path: "the-stream" },
];

export default function NavigationBar() {
  return (
    <AppBar color="secondary" position="sticky">
      <Toolbar>
        <SmallNavBar />
        <NavLink to="/">
          <Container
            component="img"
            alt="Camp Somos"
            src={logo}
            sx={{
              height: 50,
              width: "auto",
            }}
          />
        </NavLink>
        <Typography
          variant="h5"
          noWrap
          component={NavLink}
          to="/"
          sx={{
            mr: 2,
            display: { xs: "flex", md: "none" },
            flexGrow: 1,
            color: "inherit",
            textDecoration: "none",
          }}
        >
          Camp Somos
        </Typography>
        <LargeNavBar />
      </Toolbar>
    </AppBar>
  );
}

function SmallNavBar() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [expandedMenuItem, setExpandedMenuItem] = React.useState(null);
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleClick = (item) => {
    if (item === expandedMenuItem) {
      setExpandedMenuItem(null);
    } else {
      setExpandedMenuItem(item);
    }
  };

  useEffect(() => {
    setMenuOpen(false);
    setExpandedMenuItem(null);
  }, [location, isDesktop]);

  return (
    <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
      <IconButton
        size="large"
        aria-label="camp somos menu"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={() => setMenuOpen(true)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor="left"
        open={menuOpen}
        onOpen={() => {}}
        onClose={() => setMenuOpen(false)}
      >
        <Box sx={{ width: 250 }} role="presentation">
          <Typography variant="h5" color="secondary" sx={{ margin: 2 }}>
            Camp Somos
          </Typography>
          <List>
            {pages.map((page) => {
              if (page.pages) {
                return (
                  <div key={page.title}>
                    <ListItemButton
                      onClick={() => handleClick(page.path)}
                      sx={(theme) => ({
                        padding: theme.spacing(1),
                        margin: theme.spacing(0, 1),
                        borderRadius: theme.shape.borderRadius,
                        color: theme.palette.primary.main,
                        "&:hover": {
                          bgcolor: "primary.main",
                          color: "secondary.main",
                        },
                        ...(expandedMenuItem === page.path && {
                          bgcolor: "secondary.light",
                          color: "primary.main",
                          "&:hover": {
                            bgcolor: "secondary.light",
                            color: "primary.main",
                          },
                        }),
                      })}
                    >
                      <ListItemText>
                        <Typography variant="h6">{page.title}</Typography>
                      </ListItemText>
                    </ListItemButton>
                    <Collapse
                      in={expandedMenuItem === page.path}
                      timeout="auto"
                    >
                      <List component="div">
                        {page.pages.map((subpage) => (
                          <ListItemButton
                            key={subpage.title}
                            sx={(theme) => ({
                              padding: theme.spacing(1),
                              margin: theme.spacing(0, 1, 0, 4),
                              borderRadius: theme.shape.borderRadius,
                              color: theme.palette.primary.main,
                              "&:hover": {
                                bgcolor: "primary.main",
                                color: "secondary.main",
                              },
                            })}
                            component={NavLink}
                            to={`/${page.path}/${subpage.path}`}
                          >
                            <Typography variant="h6">
                              {subpage.title}
                            </Typography>
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                );
              } else {
                return (
                  <ListItemButton
                    key={page.title}
                    component={NavLink}
                    to={`/${page.path}`}
                    sx={(theme) => ({
                      padding: theme.spacing(1),
                      margin: theme.spacing(0, 1),
                      borderRadius: theme.shape.borderRadius,
                      color: theme.palette.primary.main,
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "secondary.main",
                      },
                    })}
                  >
                    <Typography variant="h6">{page.title}</Typography>
                  </ListItemButton>
                );
              }
            })}
            <ListItemButton
              key="Our Escape Rooms"
              component={NavLink}
              to="/the-photos/our-escape-rooms"
            >
              <Typography variant="h6" color="background.paper">
                Our Escape Rooms
              </Typography>
            </ListItemButton>
          </List>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
}

function LargeNavBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleOpenNavMenu = (event, path) => {
    setAnchorElNav({ anchor: event.currentTarget, path: path });
  };

  const handleCloseNavMenu = (e) => {
    setAnchorElNav(null);
  };

  useEffect(() => {
    setAnchorElNav(null);
  }, [location, isMobile]);

  return (
    <ClickAwayListener onClickAway={handleCloseNavMenu}>
      <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
        {pages.map((page) => {
          if (page.pages) {
            const open = (anchorElNav ?? {}).path === page.path;

            return (
              <div key={page.title}>
                <Button
                  id={page.title}
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(event) => handleOpenNavMenu(event, page.path)}
                  sx={(theme) => ({
                    justifyContent: "center",
                    alignItems: "center",
                    padding: theme.spacing(2),
                    margin: theme.spacing(1),
                    borderRadius: theme.shape.borderRadius,
                    "&:hover": {
                      bgcolor: "primary.main",
                      color: "secondary.main",
                    },
                  })}
                >
                  <Typography variant="h6">{page.title}</Typography>
                </Button>
                <Popper
                  id={page.title}
                  anchorEl={(anchorElNav ?? {}).anchor}
                  open={open}
                  placement="bottom"
                  sx={{ zIndex: 1200 }}
                  transition
                >
                  {({ TransitionProps }) => (
                    <Fade
                      {...TransitionProps}
                      timeout={{ exit: 0, enter: 400 }}
                    >
                      <Box
                        sx={(theme) => ({
                          padding: theme.spacing(1),
                          borderRadius: theme.shape.borderRadius,
                          bgcolor: "background.paper",
                        })}
                      >
                        <MenuList>
                          {page.pages.map((subpage) => (
                            <MenuItem
                              component={NavLink}
                              to={`/${page.path}/${subpage.path}`}
                              key={subpage.title}
                              sx={(theme) => ({
                                alignItems: "center",
                                justifyContent: "center",
                                padding: theme.spacing(1),
                                margin: theme.spacing(0),
                                borderRadius: theme.shape.borderRadius,
                                "&:hover": {
                                  bgcolor: "primary.main",
                                  color: "secondary.main",
                                },
                              })}
                            >
                              <Typography variant="body">
                                {subpage.title}
                              </Typography>
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Box>
                    </Fade>
                  )}
                </Popper>
              </div>
            );
          } else {
            return (
              <Button
                component={NavLink}
                to={`/${page.path}`}
                key={page.title}
                sx={(theme) => ({
                  borderRadius: theme.shape.borderRadius,
                  textAlign: "center",
                  padding: theme.spacing(1),
                  margin: theme.spacing(1),
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "secondary.main",
                  },
                })}
              >
                <Typography variant="h6">{page.title}</Typography>
              </Button>
            );
          }
        })}
        <Button
          id="Our Escape Rooms"
          component={NavLink}
          to="/the-photos/our-escape-rooms"
        >
          <Typography color="secondary.main" variant="h6">
            Our Escape Rooms
          </Typography>
        </Button>
      </Box>
    </ClickAwayListener>
  );
}
